// extracted by css-extract-rspack-plugin
export default {"links":"src-pages-manage-Schemas-module__links-qfj40U"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"links\":\"src-pages-manage-Schemas-module__links-qfj40U\"}";
        // 1788963434974
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  